import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface PlaybackIssue {
  id: number
  playerId: number
  channel: number
  stationId: number
}

interface PlaybackIssueState {
  current?: PlaybackIssue
}

const initialState: PlaybackIssueState = {};

const playbackIssueSlice = createSlice({
  name: 'playbackIssue',
  initialState,
  reducers: {
    showPlaybackIssue (state, { payload }: PayloadAction<Omit<PlaybackIssue, 'id'>>) {
      state.current = {
        id: (state.current?.id ?? 0) + 1,
        ...payload
      };
    }
  }
});

export const { showPlaybackIssue } = playbackIssueSlice.actions;
export default playbackIssueSlice.reducer;
